'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  separator: '||',
  delimiter: '.',
  next: 'next',
  start: 'start',
  error: 'error',
  complete: 'complete'
};


//////////////////
// WEBPACK FOOTER
// ./~/berkeleys-redux-utils/lib/config.js
// module id = 107
// module chunks = 168707334958949